// import { useState, useEffect } from 'react';
// import { 
//   MapPin, 
//   Phone, 
//   Mail, 
//   Send, 
//   CheckCircle, 
//   ArrowRight, 
//   Clock, 
//   MessageSquare, 
//   Map, 
//   ChevronDown
// } from 'lucide-react';
// import { useForm } from '@formspree/react';

// function ContactUs() {
//   const [formState, setFormState] = useState({
//     name: '',
//     email: '',
//     phone: '',
//     subject: '',
//     message: ''
//   });
  
//   // Formspree integration
//   const [formspreeState, handleFormspreeSubmit] = useForm("xnndjeaz");
//   const [formSubmitted, setFormSubmitted] = useState(false);
//   const [activeTab, setActiveTab] = useState('form');
//   const [activeAccordion, setActiveAccordion] = useState(null);
//   const [scrollPosition, setScrollPosition] = useState(0);
  
//   // Track scroll position for parallax effects
//   useEffect(() => {
//     const handleScroll = () => {
//       setScrollPosition(window.scrollY);
//     };
    
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const handleChange = (e) => {
//     setFormState({
//       ...formState,
//       [e.target.name]: e.target.value
//     });
//   };

//   const handleSubmit = (e) => {
//     // Using Formspree to handle the submission
//     handleFormspreeSubmit(e);
    
//     // Show the success message based on Formspree's state
//     if (formspreeState.succeeded) {
//       setFormSubmitted(true);
      
//       // Reset form after 3 seconds
//       setTimeout(() => {
//         setFormSubmitted(false);
//         setFormState({
//           name: '',
//           email: '',
//           phone: '',
//           subject: '',
//           message: ''
//         });
//       }, 3000);
//     }
//   };
  
//   const toggleAccordion = (index) => {
//     if (activeAccordion === index) {
//       setActiveAccordion(null);
//     } else {
//       setActiveAccordion(index);
//     }
//   };

//   const faqItems = [
//     {
//       question: "What services do you offer?",
//       answer: "We offer comprehensive structural engineering and facade connection solutions tailored for both commercial and residential projects. Our team specializes in innovative designs that blend functionality with aesthetic excellence."
//     },
//     {
//       question: "Do you provide consultations?",
//       answer: "Yes, we provide complimentary initial consultations to discuss your project requirements, goals, and budget considerations. Our expert team will evaluate your needs and provide tailored recommendations."
//     },
//     {
//       question: "What areas do you serve?",
//       answer: "While our headquarters is in Miami-Dade County, we service clients throughout Florida and have collaborated on projects nationwide. For international inquiries, please contact us directly to discuss possibilities."
//     },
//     {
//       question: "How quickly can you respond to inquiries?",
//       answer: "We pride ourselves on responsive communication. Most inquiries receive a response within 24 hours during business days. Urgent matters are prioritized and addressed as quickly as possible."
//     },
//     {
//       question: "What is your project timeline?",
//       answer: "Project timelines vary based on scope, complexity, and current workload. After our initial consultation, we'll provide a detailed timeline estimation specific to your project requirements."
//     },
//     {
//       question: "Do you offer emergency services?",
//       answer: "Yes, we understand that structural issues sometimes require immediate attention. Contact our emergency line for expedited service during critical situations."
//     }
//   ];

//   return (
//     <div className="relative overflow-hidden bg-gradient-to-b from-gray-900 via-sky-900 to-gray-900 min-h-screen">
//       {/* Animated background elements */}
//       <div className="absolute inset-0 overflow-hidden pointer-events-none">
//         <div className="absolute top-0 left-0 w-full h-full">
//           {[...Array(20)].map((_, i) => (
//             <div 
//               key={i}
//               className="absolute rounded-full bg-sky-500 opacity-5"
//               style={{
//                 top: `${Math.random() * 100}%`,
//                 left: `${Math.random() * 100}%`,
//                 width: `${Math.random() * 300 + 50}px`,
//                 height: `${Math.random() * 300 + 50}px`,
//                 transform: `translateY(${scrollPosition * (0.1 + Math.random() * 0.1)}px)`,
//                 transition: 'transform 0.1s ease-out'
//               }}
//             />
//           ))}
//         </div>
//       </div>

//       <div className="container mx-auto px-4 py-16 relative z-10">
//         {/* Header Section */}
//         <div className="text-center mb-20">
//           <div 
//             className="inline-block mb-3 relative mt-20"
//             style={{
//               transform: `translateY(${scrollPosition * -0.15}px)`,
//             }}
//           >
//             <span className="px-4 py-1 bg-sky-600 text-white text-sm font-medium rounded-full uppercase tracking-wider ">
//               Get In Touch
//             </span>
//           </div>
//           <h1 
//             className="text-5xl md:text-7xl font-bold bg-gradient-to-r from-white via-sky-200 to-white bg-clip-text text-transparent mb-6"
//             style={{
//               transform: `translateY(${scrollPosition * -0.1}px)`,
//             }}
//           >
//             Contact Us
//           </h1>
//           <p 
//             className="text-lg text-sky-100 max-w-2xl mx-auto opacity-80"
//             style={{
//               transform: `translateY(${scrollPosition * -0.05}px)`,
//             }}
//           >
//             We're ready to transform your engineering challenges into innovative solutions.
//             Reach out today and let's build something extraordinary together.
//           </p>
//         </div>

//         {/* Main Contact Card */}
//         <div 
//           className="max-w-6xl mx-auto relative rounded-2xl overflow-hidden shadow-2xl backdrop-blur-sm bg-white/10 border border-white/10"
//           style={{
//             transform: `translateY(${scrollPosition * -0.03}px)`,
//           }}
//         >
//           {/* Card Glow */}
//           <div className="absolute inset-0 bg-gradient-to-tr from-sky-500/20 via-transparent to-purple-500/20 opacity-50" />
          
//           <div className="md:flex relative z-10">
//             {/* Info Panel */}
//             <div className="bg-gradient-to-b from-sky-900 to-sky-800 text-white md:w-2/5 p-8 md:p-12 relative overflow-hidden">
//               {/* Animated accent */}
//               <div className="absolute top-0 right-0 w-64 h-64 bg-sky-600 rounded-full filter blur-3xl opacity-20 -mr-32 -mt-32" />
//               <div className="absolute bottom-0 left-0 w-64 h-64 bg-purple-600 rounded-full filter blur-3xl opacity-20 -ml-32 -mb-32" />
              
//               <div className="relative z-10">
//                 <h2 className="text-3xl font-bold mb-6 flex items-center">
//                   <span className="bg-sky-600 p-2 rounded-lg mr-3">
//                     <MessageSquare className="h-6 w-6" />
//                   </span>
//                   <span>Let's Connect</span>
//                 </h2>
                
//                 <div className="space-y-8 mb-12">
//                   <div className="flex items-start group">
//                     <div className="bg-sky-800 p-3 rounded-lg mr-4 flex-shrink-0 group-hover:bg-sky-600 transition-all duration-300">
//                       <MapPin className="text-sky-200" />
//                     </div>
//                     <div>
//                       <h3 className="font-semibold text-sky-200 mb-1">Our Location</h3>
//                       <p className="text-white/80">8322 SW 135th Ave, Miami, FL 133177</p>
//                     </div>
//                   </div>
                  
//                   <div className="flex items-start group">
//                     <div className="bg-sky-800 p-3 rounded-lg mr-4 flex-shrink-0 group-hover:bg-sky-600 transition-all duration-300">
//                       <Phone className="text-sky-200" />
//                     </div>
//                     <div>
//                       <h3 className="font-semibold text-sky-200 mb-1">Phone Number</h3>
//                       <p className="text-white/80">(305) 528-1054</p>
//                       <p className="text-white/60 text-sm mt-1">Emergency: (305) 555-9876</p>
//                     </div>
//                   </div>
                  
//                   <div className="flex items-start group">
//                     <div className="bg-sky-800 p-3 rounded-lg mr-4 flex-shrink-0 group-hover:bg-sky-600 transition-all duration-300">
//                       <Mail className="text-sky-200" />
//                     </div>
//                     <div>
//                       <h3 className="font-semibold text-sky-200 mb-1">Email Address</h3>
//                       <p className="text-white/80">crm@facadeconnection.com</p>
//                       <p className="text-white/60 text-sm mt-1">support@facadeconnection.com</p>
//                     </div>
//                   </div>
                  
//                   <div className="flex items-start group">
//                     <div className="bg-sky-800 p-3 rounded-lg mr-4 flex-shrink-0 group-hover:bg-sky-600 transition-all duration-300">
//                       <Clock className="text-sky-200" />
//                     </div>
//                     <div>
//                       <h3 className="font-semibold text-sky-200 mb-1">Office Hours</h3>
//                       <p className="text-white/80">Monday - Friday: 9:00 AM - 6:00 PM</p>
//                       <p className="text-white/80">Saturday - Sunday: Closed</p>
//                     </div>
//                   </div>
//                 </div>
                
//                 <div className="pt-8 border-t border-sky-700/50">
//                   <h3 className="text-xl font-semibold mb-4">Connect With Us</h3>
//                   <div className="flex space-x-3">
//                     {['facebook', 'twitter', 'instagram', 'linkedin'].map((social, index) => (
//                       <a 
//                         key={index}
//                         href="#" 
//                         className="bg-sky-800 hover:bg-sky-600 transition-all duration-300 p-3 rounded-lg group"
//                       >
//                         <div className="w-5 h-5 text-white group-hover:scale-110 transition-transform duration-300">
//                           {social === 'facebook' && (
//                             <svg fill="currentColor" viewBox="0 0 24 24">
//                               <path d="M22,12.07A10,10,0,0,1,17.09,21c-.14,0-.29,0-.43,0V14.88h2l.3-2.3H16.66v-1.5c0-.67.18-1.13,1.14-1.13h1.22V7.9a16,16,0,0,0-1.79-.09,2.8,2.8,0,0,0-3,3.08v1.69H12v2.3h2.2v6c-5.55-.45-9.4-5.22-8.95-10.7s5.3-9.4,10.78-8.95A10,10,0,0,1,22,12.07Z"/>
//                             </svg>
//                           )}
//                           {social === 'twitter' && (
//                             <svg fill="currentColor" viewBox="0 0 24 24">
//                               <path d="M22.46,6c-.77.35-1.6.58-2.46.69.88-.53,1.56-1.37,1.88-2.38-.83.5-1.75.85-2.72,1.05C18.37,4.5,17.26,4,16,4a4.67,4.67,0,0,0-4.67,4.67A4.41,4.41,0,0,0,11.46,9,13.31,13.31,0,0,1,1.67,4.92,4.85,4.85,0,0,0,1,7a4.78,4.78,0,0,0,2.11,3.89A4.49,4.49,0,0,1,1,10.31v.06A4.65,4.65,0,0,0,4.66,15a4.41,4.41,0,0,1-1.23.16,4.67,4.67,0,0,1-.88-.08,4.63,4.63,0,0,0,4.33,3.23,9.29,9.29,0,0,1-5.79,2A9.55,9.55,0,0,1,0,20.29a13.29,13.29,0,0,0,7.19,2.11A13.13,13.13,0,0,0,20.37,9.19c0-.2,0-.4,0-.6A9.67,9.67,0,0,0,22.46,6Z"/>
//                             </svg>
//                           )}
//                           {social === 'instagram' && (
//                             <svg fill="currentColor" viewBox="0 0 24 24">
//                               <path d="M12,2.16c3.2,0,3.58,0,4.85.07,1.17.05,1.8.25,2.23.41a3.78,3.78,0,0,1,1.38.89,3.55,3.55,0,0,1,.89,1.38c.16.43.36,1.06.41,2.23.06,1.27.07,1.65.07,4.85s0,3.58-.07,4.85c-.05,1.17-.25,1.8-.41,2.23a3.78,3.78,0,0,1-.89,1.38,3.55,3.55,0,0,1-1.38.89c-.43.16-1.06.36-2.23.41-1.27.06-1.65.07-4.85.07s-3.58,0-4.85-.07c-1.17-.05-1.8-.25-2.23-.41a3.78,3.78,0,0,1-1.38-.89,3.55,3.55,0,0,1-.89-1.38c-.16-.43-.36-1.06-.41-2.23-.06-1.27-.07-1.65-.07-4.85s0-3.58.07-4.85c.05-1.17.25-1.8.41-2.23a3.78,3.78,0,0,1,.89-1.38,3.55,3.55,0,0,1,1.38-.89c.43-.16,1.06-.36,2.23-.41C8.42,2.17,8.8,2.16,12,2.16Zm0-2c-3.26,0-3.67,0-4.95.07S4.68.47,4,.73A5.48,5.48,0,0,0,2,2,5.48,5.48,0,0,0,.73,4C.47,4.68.19,5.6.12,6.87S0,8.74,0,12s0,3.67.07,4.95S.47,19.32.73,20A5.48,5.48,0,0,0,2,22,5.48,5.48,0,0,0,4,23.27c.68.26,1.6.54,2.87.61S8.74,24,12,24s3.67,0,4.95-.07,2.19-.35,2.87-.61A5.48,5.48,0,0,0,22,22a5.48,5.48,0,0,0,1.27-2c.26-.68.54-1.6.61-2.87S24,15.26,24,12s0-3.67-.07-4.95S23.53,4.68,23.27,4A5.48,5.48,0,0,0,22,2,5.48,5.48,0,0,0,20,0.73c-.68-.26-1.6-.54-2.87-.61S15.26,0,12,0Z"/>
//                               <path d="M12,5.84A6.16,6.16,0,1,0,18.16,12,6.16,6.16,0,0,0,12,5.84Zm0,10.15A4,4,0,1,1,16,12,4,4,0,0,1,12,16Z"/>
//                               <path d="M19.85,5.6a1.44,1.44,0,1,1-1.44-1.44A1.44,1.44,0,0,1,19.85,5.6Z"/>
//                             </svg>
//                           )}
//                           {social === 'linkedin' && (
//                             <svg fill="currentColor" viewBox="0 0 24 24">
//                               <path d="M19,3H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V5A2,2,0,0,0,19,3ZM8.5,6.5A2,2,0,1,1,6.5,8.5,2,2,0,0,1,8.5,6.5ZM6.5,18a.47.47,0,0,1-.5-.5v-5A.47.47,0,0,1,6.5,12H8a.47.47,0,0,1,.5.5v5a.47.47,0,0,1-.5.5ZM18,18a.47.47,0,0,1-.5.5h-5a.47.47,0,0,1-.5-.5V12.5a.47.47,0,0,1,.5-.5h1a.47.47,0,0,1,.5.5V13a2.5,2.5,0,0,1,2-1c1.65,0,2,1.3,2,3v3.5Z"/>
//                             </svg>
//                           )}
//                         </div>
//                       </a>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             </div>
            
//             {/* Form Section */}
//             <div className="md:w-3/5 p-8 md:p-12 relative backdrop-blur-sm">
//               {/* Tabs */}
//               <div className="flex mb-8 p-1 bg-white/10 backdrop-blur-sm rounded-xl">
//                 <button
//                   type="button"
//                   className={`flex-1 flex items-center justify-center py-3 px-4 rounded-lg text-sm font-medium transition-all duration-300 ${
//                     activeTab === 'form' 
//                       ? 'bg-gradient-to-r from-sky-500 to-sky-600 text-white shadow-lg' 
//                       : 'text-white/70 hover:text-white hover:bg-white/5'
//                   }`}
//                   onClick={() => setActiveTab('form')}
//                 >
//                   <MessageSquare className="w-4 h-4 mr-2" />
//                   Contact Form
//                 </button>
//                 <button
//                   type="button"
//                   className={`flex-1 flex items-center justify-center py-3 px-4 rounded-lg text-sm font-medium transition-all duration-300 ${
//                     activeTab === 'map' 
//                       ? 'bg-gradient-to-r from-sky-500 to-sky-600 text-white shadow-lg' 
//                       : 'text-white/70 hover:text-white hover:bg-white/5'
//                   }`}
//                   onClick={() => setActiveTab('map')}
//                 >
//                   <Map className="w-4 h-4 mr-2" />
//                   Find Us
//                 </button>
//               </div>
              
//               {activeTab === 'form' ? (
//                 <div>
//                   <h2 className="text-3xl font-bold text-white mb-8">Get In Touch</h2>
                  
//                   {formSubmitted || formspreeState.succeeded ? (
//                     <div className="bg-gradient-to-r from-green-500/20 to-sky-500/20 backdrop-blur-sm border border-green-300/30 rounded-2xl p-8 text-center">
//                       <div className="inline-flex items-center justify-center w-16 h-16 mb-6 rounded-full bg-gradient-to-r from-green-500 to-sky-500">
//                         <CheckCircle className="w-8 h-8 text-white" />
//                       </div>
//                       <h3 className="text-2xl font-semibold text-white mb-2">Message Sent!</h3>
//                       <p className="text-sky-100/80">We've received your message and will get back to you shortly. Thank you for reaching out!</p>
//                     </div>
//                   ) : (
//                     <form onSubmit={handleSubmit} className="space-y-6">
//                       <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                         <div>
//                           <label className="block text-sky-100 text-sm font-medium mb-2">
//                             Your Name <span className="text-sky-400">*</span>
//                           </label>
//                           <div className="relative">
//                             <input
//                               type="text"
//                               name="name"
//                               value={formState.name}
//                               onChange={handleChange}
//                               required
//                               className="w-full px-4 py-3 bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg text-white placeholder:text-white/50 focus:outline-none focus:ring-2 focus:ring-sky-500 focus:border-transparent"
//                               placeholder="John Doe"
//                             />
//                           </div>
//                         </div>
                        
//                         <div>
//                           <label className="block text-sky-100 text-sm font-medium mb-2">
//                             Email Address <span className="text-sky-400">*</span>
//                           </label>
//                           <div className="relative">
//                             <input
//                               type="email"
//                               name="email"
//                               id="email"
//                               value={formState.email}
//                               onChange={handleChange}
//                               required
//                               className="w-full px-4 py-3 bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg text-white placeholder:text-white/50 focus:outline-none focus:ring-2 focus:ring-sky-500 focus:border-transparent"
//                               placeholder="you@example.com"
//                             />
//                           </div>
//                         </div>
//                       </div>
                      
//                       <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                         <div>
//                           <label className="block text-sky-100 text-sm font-medium mb-2">
//                             Phone Number
//                           </label>
//                           <div className="relative">
//                             <input
//                               type="tel"
//                               name="phone"
//                               value={formState.phone}
//                               onChange={handleChange}
//                               className="w-full px-4 py-3 bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg text-white placeholder:text-white/50 focus:outline-none focus:ring-2 focus:ring-sky-500 focus:border-transparent"
//                               placeholder="(123) 456-7890"
//                             />
//                           </div>
//                         </div>
                        
//                         <div>
//                           <label className="block text-sky-100 text-sm font-medium mb-2">
//                             Subject <span className="text-sky-400">*</span>
//                           </label>
//                           <div className="relative">
//                             <input
//                               type="text"
//                               name="subject"
//                               value={formState.subject}
//                               onChange={handleChange}
//                               required
//                               className="w-full px-4 py-3 bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg text-white placeholder:text-white/50 focus:outline-none focus:ring-2 focus:ring-sky-500 focus:border-transparent"
//                               placeholder="Project Inquiry"
//                             />
//                           </div>
//                         </div>
//                       </div>
                      
//                       <div>
//                         <label className="block text-sky-100 text-sm font-medium mb-2">
//                           Your Message <span className="text-sky-400">*</span>
//                         </label>
//                         <div className="relative">
//                           <textarea
//                             name="message"
//                             id="message"
//                             value={formState.message}
//                             onChange={handleChange}
//                             required
//                             rows="5"
//                             className="w-full px-4 py-3 bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg text-white placeholder:text-white/50 focus:outline-none focus:ring-2 focus:ring-sky-500 focus:border-transparent resize-none"
//                             placeholder="How can we help you with your project?"
//                           ></textarea>
//                         </div>
//                       </div>
                      
//                       <button
//                         type="submit"
//                         disabled={formspreeState.submitting}
//                         className="w-full bg-gradient-to-r from-sky-500 to-sky-600 hover:from-sky-600 hover:to-sky-700 text-white py-4 px-6 rounded-lg transition-all duration-300 transform hover:scale-[1.01] flex items-center justify-center disabled:opacity-70 disabled:cursor-not-allowed disabled:hover:scale-100 group shadow-lg shadow-sky-500/25"
//                       >
//                         <span className="mr-2">{formspreeState.submitting ? 'Sending...' : 'Send Message'}</span>
//                         <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
//                       </button>
//                     </form>
//                   )}
//                 </div>
//               ) : (
//                 <div>
//                   <h2 className="text-3xl font-bold text-white mb-8">Find Our Location</h2>
//                   <div className="rounded-2xl overflow-hidden shadow-xl h-96 relative">
//                     {/* Replace this with actual map integration */}
//                     <div className="absolute inset-0 bg-gradient-to-br from-gray-800 to-gray-900 flex items-center justify-center">
//                       <div className="text-center">
//                         <div className="inline-flex items-center justify-center w-16 h-16 mb-6 rounded-full bg-gradient-to-r from-sky-500 to-sky-600">
//                           <MapPin className="w-8 h-8 text-white" />
//                         </div>
//                         <p className="text-sky-100 mb-4 font-medium text-xl">Our Miami Headquarters</p>
//                         <p className="text-white/70">8322 SW 135th Ave, Miami, FL 133177</p>
//                       </div>
//                     </div>
                    
//                     {/* For production, you would use something like: */}
//                     {/* 
//                     <iframe 
//                       src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3593.9509673509193!2d-80.4152896!3d25.6933415!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88d9c16ec66ea2f1%3A0x5e73a36b5c1bbd15!2s8322%20SW%20135th%20Ave%2C%20Miami%2C%20FL%2033183!5e0!3m2!1sen!2sus!4v1620123456789!5m2!1sen!2sus" 
//                       width="100%" 
//                       height="100%" 
//                       style={{border:0}} 
//                       allowFullScreen="" 
//                       loading="lazy"
//                     ></iframe>
//                     */}
//                   </div>
                  
//                   <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6">
//                     <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/10">
//                       <h3 className="font-semibold text-white mb-3 flex items-center">
//                         <span className="bg-sky-600 p-1 rounded-md mr-2 inline-flex">
//                           <MapPin className="w-4 h-4" />
//                         </span>
//                         Directions
//                       </h3>
//                       <p className="text-sky-100/70">Located in Southwest Miami, our office is easily accessible from the Florida Turnpike. Free parking is available on-site for your convenience.</p>
//                     </div>
                    
//                     <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/10">
//                       <h3 className="font-semibold text-white mb-3 flex items-center">
//                         <span className="bg-sky-600 p-1 rounded-md mr-2 inline-flex">
//                           <Clock className="w-4 h-4" />
//                         </span>
//                         Public Transportation
//                       </h3>
//                       <p className="text-sky-100/70">Our office is accessible via Miami-Dade Transit bus routes 88 and 137. The nearest bus stop is a 5-minute walk from our location.</p>
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
        
//         {/* FAQ Section */}
//         <div className="mt-24 max-w-4xl mx-auto relative z-10">
//           <div className="text-center mb-12">
//             <span className="px-4 py-1 bg-sky-600 text-white text-sm font-medium rounded-full uppercase tracking-wider">
//               Questions & Answers
//             </span>
//             <h2 className="text-4xl font-bold text-white mt-4">Frequently Asked Questions</h2>
//             <p className="text-sky-100/70 mt-4">Find answers to the most common questions about our services and company</p>
//           </div>
          
//           <div className="space-y-4">
//             {faqItems.map((item, index) => (
//               <div 
//                 key={index}
//                 className="bg-white/10 backdrop-blur-sm border border-white/10 rounded-xl overflow-hidden"
//               >
//                 <button
//                   className="w-full px-6 py-4 flex items-center justify-between text-left focus:outline-none"
//                   onClick={() => toggleAccordion(index)}
//                 >
//                   <h3 className="font-medium text-lg text-white">{item.question}</h3>
//                   <ChevronDown 
//                     className={`w-5 h-5 text-sky-300 transition-transform duration-300 ${
//                       activeAccordion === index ? 'transform rotate-180' : ''
//                     }`} 
//                   />
//                 </button>
//                 <div 
//                   className={`px-6 overflow-hidden transition-all duration-300 ${
//                     activeAccordion === index ? 'max-h-60 pb-6' : 'max-h-0'
//                   }`}
//                 >
//                   <p className="text-sky-100/70">{item.answer}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default ContactUs;






import { useState } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail, Send, CheckCircle } from 'lucide-react';

function ContactUs() {
  const [formState, setFormState] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [formError, setFormError] = useState(null);
  const [activeTab, setActiveTab] = useState('form');

  const handleChange = (e) => {
    setFormState({
      ...formState,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const response = await fetch('https://formsubmit.co/ajax/info@facadeconnection.com', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          name: formState.name,
          email: formState.email,
          phone: formState.phone,
          subject: formState.subject,
          message: formState.message
        })
      });

      const data = await response.json();

      if (data.success) {
        setFormSubmitted(true);
        
        // Reset form after 3 seconds
        setTimeout(() => {
          setFormSubmitted(false);
          setFormState({
            name: '',
            email: '',
            phone: '',
            subject: '',
            message: ''
          });
        }, 3000);
      } else {
        setFormError('Failed to send message. Please try again.');
      }
    } catch (error) {
      setFormError('An error occurred. Please try again later.');
    }
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 }
  };

  return (
    <div className="bg-gradient-to-b from-gray-50 to-gray-100 min-h-screen py-16">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h1 className="text-4xl md:text-5xl font-bold text-sky-700 mb-4 mt-20">Get In Touch</h1>
          <div className=" W-24 bg-sky-500 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            We'd love to hear from you. Reach out for your structural engineering and facade connection needs.
          </p>
        </motion.div>

        <div className="max-w-6xl mx-auto bg-white rounded-xl shadow-lg overflow-hidden">
          <div className="md:flex">
            {/* Info Panel */}
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              className="bg-sky-700 text-white md:w-2/5 p-8"
            >
              <h2 className="text-2xl font-bold mb-6">Contact Information</h2>
              
              <motion.div
                variants={containerVariants}
                initial="hidden"
                animate="visible"
                className="space-y-6"
              >
                <motion.div variants={itemVariants} className="flex items-start">
                  <MapPin className="mr-4 flex-shrink-0 text-sky-300" />
                  <div>
                    <h3 className="font-semibold text-sky-200">Our Location</h3>
                    <p className="mt-1">18322 SW 135th Ave, Miami, FL 33177</p>
                  </div>
                </motion.div>
                
                <motion.div variants={itemVariants} className="flex items-start">
                  <Phone className="mr-4 flex-shrink-0 text-sky-300" />
                  <div>
                    <h3 className="font-semibold text-sky-200">Phone Number</h3>
                    <p className="mt-1">(305) 528-1054</p>
                  </div>
                </motion.div>
                
                <motion.div variants={itemVariants} className="flex items-start">
                  <Mail className="mr-4 flex-shrink-0 text-sky-300" />
                  <div>
                    <h3 className="font-semibold text-sky-200">Email Address</h3>
                    <p className="mt-1">info@facadeconnection.com</p>
                  </div>
                </motion.div>
              </motion.div>
              
            
              
              <div className="mt-12 pt-8 border-t border-sky-600">
                <h3 className="text-xl font-semibold mb-4">Office Hours</h3>
                <p className="mb-2">Monday - Friday: 9:00 AM - 6:00 PM</p>
                <p>Saturday - Sunday: Closed</p>
              </div>
            </motion.div>
            
            {/* Form Section */}
            <motion.div 
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              className="md:w-3/5 p-8"
            >
              <div className="mb-6">
                <div className="inline-flex rounded-md shadow-sm mb-6">
                  <button
                    type="button"
                    className={`px-4 py-2 text-sm font-medium rounded-l-lg ${
                      activeTab === 'form' 
                        ? 'bg-sky-600 text-white' 
                        : 'bg-white text-gray-700 hover:bg-gray-100'
                    }`}
                    onClick={() => setActiveTab('form')}
                  >
                    Contact Form
                  </button>
                  <button
                    type="button"
                    className={`px-4 py-2 text-sm font-medium rounded-r-lg ${
                      activeTab === 'map' 
                        ? 'bg-sky-600 text-white' 
                        : 'bg-white text-gray-700 hover:bg-gray-100'
                    }`}
                    onClick={() => setActiveTab('map')}
                  >
                    Find Us
                  </button>
                </div>
              </div>
              
              {activeTab === 'form' ? (
                <div>
                  <h2 className="text-2xl font-bold text-gray-800 mb-6">Send Us a Message</h2>
                  
                  {formSubmitted ? (
                    <motion.div
                      initial={{ opacity: 0, scale: 0.8 }}
                      animate={{ opacity: 1, scale: 1 }}
                      className="bg-green-50 border border-green-200 rounded-lg p-6 text-center"
                    >
                      <CheckCircle className="w-12 h-12 text-green-500 mx-auto mb-4" />
                      <h3 className="text-xl font-semibold text-green-800">Thank You!</h3>
                      <p className="text-green-700 mt-2">Your message has been sent successfully. We'll get back to you shortly.</p>
                    </motion.div>
                  ) : (
                    <div>
                      {formError && (
                        <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-4 text-red-700">
                          {formError}
                        </div>
                      )}
                      <form onSubmit={handleSubmit}>
                        <motion.div
                          variants={containerVariants}
                          initial="hidden"
                          animate="visible"
                          className="space-y-4"
                        >
                          <motion.div variants={itemVariants} className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                              <label className="block text-gray-700 text-sm font-medium mb-1">
                                Your Name <span className="text-red-500">*</span>
                              </label>
                              <input
                                type="text"
                                name="name"
                                value={formState.name}
                                onChange={handleChange}
                                required
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-sky-500"
                                placeholder="John Doe"
                              />
                            </div>
                            
                            <div>
                              <label className="block text-gray-700 text-sm font-medium mb-1">
                                Email Address <span className="text-red-500">*</span>
                              </label>
                              <input
                                type="email"
                                name="email"
                                id="email"
                                value={formState.email}
                                onChange={handleChange}
                                required
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-sky-500"
                                placeholder="you@example.com"
                              />
                            </div>
                          </motion.div>
                          
                          <motion.div variants={itemVariants} className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                              <label className="block text-gray-700 text-sm font-medium mb-1">
                                Phone Number
                              </label>
                              <input
                                type="tel"
                                name="phone"
                                value={formState.phone}
                                onChange={handleChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-sky-500"
                                placeholder="(123) 456-7890"
                              />
                            </div>
                            
                            <div>
                              <label className="block text-gray-700 text-sm font-medium mb-1">
                                Subject <span className="text-red-500">*</span>
                              </label>
                              <input
                                type="text"
                                name="subject"
                                value={formState.subject}
                                onChange={handleChange}
                                required
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-sky-500"
                                placeholder="Project Inquiry"
                              />
                            </div>
                          </motion.div>
                          
                          <motion.div variants={itemVariants}>
                            <label className="block text-gray-700 text-sm font-medium mb-1">
                              Your Message <span className="text-red-500">*</span>
                            </label>
                            <textarea
                              name="message"
                              id="message"
                              value={formState.message}
                              onChange={handleChange}
                              required
                              rows="5"
                              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-sky-500"
                              placeholder="How can we help you?"
                            ></textarea>
                          </motion.div>
                          
                          <motion.div variants={itemVariants}>
                            <button
                              type="submit"
                              className="w-full bg-sky-600 hover:bg-sky-700 text-white py-3 rounded-md transition flex items-center justify-center disabled:bg-sky-400 disabled:cursor-not-allowed"
                            >
                              <Send className="mr-2 h-4 w-4" />
                              Send Message
                            </button>
                          </motion.div>
                        </motion.div>
                      </form>
                    </div>
                  )}
                </div>
              ) : (
                <div>
                  <h2 className="text-2xl font-bold text-gray-800 mb-6">Find Our Location</h2>
                  <div className="rounded-lg overflow-hidden shadow-md h-96 relative">
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3785.6172455715764!2d-80.4111034!3d25.5979222!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88d9c24d3a9e5abd%3A0x2f2ec93cdfd36157!2s18322%20SW%20135th%20Ave%2C%20Miami%2C%20FL%2033177%2C%20USA!5e1!3m2!1sen!2sin!4v1747196521821!5m2!1sen!2sin"
                      width="100%"
                      height="100%"
                      style={{ border: 0 }}
                      allowFullScreen=""
                      loading="lazy"
                    ></iframe>
                  </div>
                  
                  <div className="mt-6 bg-gray-50 p-4 rounded-lg border border-gray-200">
                    <h3 className="font-medium text-gray-800 mb-2">Directions</h3>
                    <p className="text-gray-600">Located in Southwest Miami, our office is easily accessible from the Florida Turnpike. Free parking is available on-site for your convenience.</p>
                  </div>
                </div>
              )}
            </motion.div>
          </div>
        </div>
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="mt-16 text-center"
        >
          <h2 className="text-2xl font-bold text-gray-800 mb-6">Frequently Asked Questions</h2>
          
          <div className="max-w-3xl mx-auto grid gap-4 md:grid-cols-2">
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <h3 className="font-semibold text-sky-700 mb-2">What services do you offer?</h3>
              <p className="text-gray-600">We specialize in structural engineering and facade connection solutions for commercial and residential projects.</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <h3 className="font-semibold text-sky-700 mb-2">Do you provide consultations?</h3>
              <p className="text-gray-600">Yes, we offer free initial consultations to discuss your project needs and requirements.</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <h3 className="font-semibold text-sky-700 mb-2">What areas do you serve?</h3>
              <p className="text-gray-600">We primarily serve the Miami-Dade area, but also work on projects throughout Florida and beyond.</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <h3 className="font-semibold text-sky-700 mb-2">How quickly can you respond?</h3>
              <p className="text-gray-600">We typically respond to all inquiries within 24-48 hours during regular business hours.</p>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
}

export default ContactUs;
